// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u41R7PAlaeI3VhjEnVnC{justify-content:space-between;align-items:center;display:flex}.johsTdqp5agqXwr6Y7gy{opacity:0;transition:opacity .2s ease-in-out}.u41R7PAlaeI3VhjEnVnC:hover .johsTdqp5agqXwr6Y7gy{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requestUrl": `u41R7PAlaeI3VhjEnVnC`,
	"copyButton": `johsTdqp5agqXwr6Y7gy`
};
export default ___CSS_LOADER_EXPORT___;
